(() => {
  function mount(root) {
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    let visible = false;
    let frame = 0;
    let time = 0;
    let previous = 0;
    const motionButtons = root.querySelectorAll('.ozj-motion, [data-motion-toggle]');
    const lab = root.querySelector('.ozj-lab');
    const canvas = lab.querySelector('.ozj-micro canvas');
    const ctx = canvas.getContext('2d');
    const body = document.querySelector('.ozj-body');
    const video = body.querySelector('video');
    const brain = document.querySelector('.ozj-brain-scene');
    const chart = document.querySelector('.ozj-chart');
    let videoVisible = false;
    let healthy = true;
    function updateMessage() {
      root.querySelector('[data-result-heading]').innerHTML = healthy ? 'More GLP-1.<br>Less hunger.' : 'Less GLP-1.<br>More hunger.';
      root.querySelector('[data-brain-message]').textContent = healthy ? 'Your brain gets a stronger “I’m full” message.' : 'A weaker “I’m full” message can leave you hungry.';
      root.querySelector('[data-fullness]').textContent = healthy ? '↑' : '↓';
      root.querySelector('[data-hunger]').textContent = healthy ? '↓' : '↑';
      lab.querySelector('.ozj-label-signal').textContent = healthy ? 'MORE GLP-1' : 'LESS GLP-1';
      root.querySelector('[data-barrier-caption]').textContent=healthy?'Tight lining. Unwanted particles stay out.':'Gaps in the lining let more unwanted particles through.';
      root.querySelector('.ozj-outcome-line').setAttribute('aria-label', healthy ? 'Fullness increases. Hunger decreases.' : 'Fullness decreases. Hunger increases.');
    }
    // Icon vocabulary stays identical in the animation and its legend.
    function particle(kind, x, y, r, alpha=1, paint=ctx) {
      paint.save();paint.translate(x,y);paint.globalAlpha=alpha;
      paint.shadowColor=kind==='signal'?'#72b9d766':kind==='fuel'?'#85bb9366':'#d9786550';paint.shadowBlur=6;
      const fill=paint.createRadialGradient(-r*.35,-r*.4,0,0,0,r*1.2);
      fill.addColorStop(0,kind==='signal'?'#d0edf8':kind==='fuel'?'#b5dfbb':'#ef9d89');
      fill.addColorStop(1,kind==='signal'?'#71b7d5':kind==='fuel'?'#69a879':'#ca6559');
      paint.beginPath();
      if(kind==='signal')paint.arc(0,0,r,0,Math.PI*2);
      else for(let j=0;j<(kind==='fuel'?6:16);j++){
        const angle=j*Math.PI*2/(kind==='fuel'?6:16)-Math.PI/2;
        const radius=kind==='fuel'?r:(j%2?r*.78:r);
        j?paint.lineTo(Math.cos(angle)*radius,Math.sin(angle)*radius):paint.moveTo(Math.cos(angle)*radius,Math.sin(angle)*radius);
      }
      paint.closePath();paint.fillStyle=fill;paint.fill();paint.shadowBlur=0;
      paint.strokeStyle=kind==='signal'?'#4e9ebf':kind==='fuel'?'#4e8f60':'#ba574b';paint.lineWidth=1;paint.stroke();
      if(kind==='fuel'){
        paint.fillStyle='#f5ffef';paint.beginPath();paint.moveTo(r*.12,-r*.65);paint.lineTo(-r*.38,r*.1);paint.lineTo(-r*.02,r*.1);paint.lineTo(-r*.16,r*.66);paint.lineTo(r*.42,-r*.18);paint.lineTo(r*.06,-r*.18);paint.closePath();paint.fill();
      }else if(kind==='signal'){
        paint.fillStyle='#286580';[-.32,.32].forEach(v=>{paint.beginPath();paint.arc(r*v,-r*.19,r*.10,0,Math.PI*2);paint.fill()});
        paint.beginPath();paint.arc(0,r*.02,r*.43,.15*Math.PI,.85*Math.PI);paint.strokeStyle='#286580';paint.lineWidth=1.5;paint.lineCap='round';paint.stroke();
      }else{
        paint.fillStyle='#a64e4655';[[-.25,-.2],[.3,.13],[-.18,.36]].forEach(v=>{paint.beginPath();paint.arc(v[0]*r,v[1]*r,r*.17,0,Math.PI*2);paint.fill()});
      }
      paint.restore();
    }
    function draw() {
      if (!ctx) return;
      const w=canvas.clientWidth,h=canvas.clientHeight,dpr=Math.min(devicePixelRatio||1,2);
      if(canvas.width!==Math.round(w*dpr)||canvas.height!==Math.round(h*dpr)){canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr)}
      ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,w,h);
      const size=Math.max(9,Math.min(14,w*.028));
      // Schematic vessel: soft walls, directional flow, and subdued blood cells.
      const vesselY=x=>h*(.845+Math.sin(x/w*Math.PI*2)*.012);
      ctx.save();
      const blood=ctx.createLinearGradient(0,h*.755,0,h*.95);
      blood.addColorStop(0,'#c58a8766');blood.addColorStop(.20,'#e2aaa59c');blood.addColorStop(.5,'#efd0c9c9');blood.addColorStop(.82,'#dca19a99');blood.addColorStop(1,'#b9777455');
      ctx.beginPath();ctx.moveTo(0,vesselY(0)-h*.07);
      for(let x=0;x<=w+8;x+=8)ctx.lineTo(x,vesselY(x)-h*.07);
      for(let x=w+8;x>=0;x-=8)ctx.lineTo(x,vesselY(x)+h*.07);
      ctx.closePath();ctx.fillStyle=blood;ctx.fill();ctx.strokeStyle='#be8f8466';ctx.lineWidth=1.2;ctx.stroke();
      for(let i=0;i<10;i++){
        const x=((time*.065+i*.113)%1)*w,y=vesselY(x)+Math.sin(i*4.1)*h*.039;
        ctx.beginPath();ctx.ellipse(x,y,size*.8,size*.35,-.15,0,Math.PI*2);ctx.fillStyle='#b6716b32';ctx.fill();
      }
      for(let i=0;i<4;i++){
        const x=((time*.07+i*.25)%1)*w,y=vesselY(x)+h*.048;
        ctx.beginPath();ctx.moveTo(x-10,y);ctx.lineTo(x+8,y);ctx.lineTo(x+4,y-3);ctx.moveTo(x+8,y);ctx.lineTo(x+4,y+3);ctx.strokeStyle='#a1666455';ctx.lineWidth=1;ctx.stroke();
      }
      ctx.restore();
      // Absorbed fuel fades inside the cells, rather than passing between them.
      for(let i=0;i<(healthy?7:3);i++){
        const t=(time*.095+i*.147)%1,x=w*(.12+(i*.137)%.78),y=h*(.13+t*.43);
        particle('fuel',x,y,size,Math.min(1,(1-t)*5));
      }
      // Some particles follow the actual gaps in the compromised illustration.
      const lanes=[.319,.57,.821,.19,.45];
      lanes.forEach((lane,i)=>{
        const t=(time*.085+i*.207)%1,passes=!healthy&&i<3;
        if(passes){
          const entry=.74, x=w*lane, y=vesselY(x);
          if(t<entry){particle('junk',x,h*.12+(y-h*.12)*(t/entry),size*.8);return;}
          const burst=(t-entry)/(1-entry),radius=size+burst*size*2.6;
          ctx.save();
          const puff=ctx.createRadialGradient(x,y,0,x,y,radius);
          puff.addColorStop(0,'rgba(199,83,67,'+(.28*(1-burst))+')');puff.addColorStop(1,'rgba(199,83,67,0)');
          ctx.fillStyle=puff;ctx.beginPath();ctx.arc(x,y,radius,0,Math.PI*2);ctx.fill();
          ctx.strokeStyle='rgba(187,73,59,'+(.55*(1-burst))+')';ctx.lineWidth=1.2;ctx.beginPath();ctx.arc(x,y,radius*.8,0,Math.PI*2);ctx.stroke();
          for(let j=0;j<7;j++){
            const angle=j*Math.PI*2/7;
            ctx.fillStyle='rgba(192,78,61,'+(.8*(1-burst))+')';ctx.beginPath();ctx.arc(x+Math.cos(angle)*radius,y+Math.sin(angle)*radius*.7,2.4*(1-burst)+.5,0,Math.PI*2);ctx.fill();
          }
          ctx.restore();return;
        }
        const hit=.62;
        if(t<hit){particle('junk',w*lane,h*(.12+(t/hit)*.235),size*.85);return;}
        const burst=(t-hit)/.2;
        if(burst>1)return;
        // Soft fragments signify rejection, not a literal biological explosion.
        for(let j=0;j<6;j++){
          const angle=j*Math.PI/3;
          ctx.save();ctx.globalAlpha=(1-burst)*.65;ctx.fillStyle='#89a588';ctx.beginPath();
          ctx.arc(w*lane+Math.cos(angle)*(size+burst*18),h*.355+Math.sin(angle)*(size+burst*12),2*(1-burst)+.4,0,Math.PI*2);ctx.fill();ctx.restore();
        }
      });
      for(let i=0;i<(healthy?6:2);i++){
        const t=(time*.10+i*.171)%1;
        const source=w*(.12+(i*.131)%.7),entry=.22;
        const x=t<entry?source:source+(t-entry)/(1-entry)*w*.9;
        const y=t<entry?h*.69+(vesselY(source)-h*.69)*(t/entry):vesselY(x)-h*.01;
        particle('signal',x,y,size,Math.min(1,t*10,(1-t)*10));
      }
    }
    function tick(now) {
      frame=0;
      if(paused || !visible || document.hidden) {previous=0;return;}
      const delta = previous ? Math.min((now-previous)/1000,.05) : 0;
      time += delta * 3;
      previous=now;draw();frame=requestAnimationFrame(tick);
    }
    function run() { if(!frame && !paused && visible && !document.hidden) frame=requestAnimationFrame(tick); }
    function updateVideo(){
      if(paused || !videoVisible || document.hidden){video.pause();return;}
      video.play().then(()=>video.classList.add('is-playing')).catch(()=>video.classList.remove('is-playing'));
    }
    function updateMotion(){
      root.classList.toggle('is-paused',paused);
      document.querySelector('.ozj-lower-science')?.classList.toggle('is-paused',paused);
      motionButtons.forEach(button=>{button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Play motion':'Pause motion';});
      if(paused){cancelAnimationFrame(frame);frame=0;previous=0;}else run();
      updateVideo();draw();
    }
    motionButtons.forEach(button=>button.addEventListener('click',()=>{paused=!paused;updateMotion()}));
    const onReducedChange=()=>{paused=reduced.matches;updateMotion()};
    reduced.addEventListener('change',onReducedChange);
    lab.querySelectorAll('[data-gut]').forEach(button=>button.addEventListener('click',()=>{
      const state=button.dataset.gut;healthy=state==='supported';lab.dataset.gutState=state;
      lab.querySelectorAll('[data-gut]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      updateMessage();draw();
    }));
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.target===lab){visible=e.isIntersecting;if(visible)run();}
      if(e.target===body){videoVisible=e.isIntersecting;updateVideo();}
      if(e.target===brain)brain.classList.toggle('is-visible',e.isIntersecting);
      if(e.target.matches('.ozj-chart') && e.isIntersecting)e.target.classList.add('is-visible');
    }),{rootMargin:'80px'});
    observer.observe(lab);observer.observe(body);if(brain)observer.observe(brain);observer.observe(chart);
    const resizeObserver=new ResizeObserver(draw);resizeObserver.observe(canvas);
    const onVisibility=()=>{run();updateVideo()};
    document.addEventListener('visibilitychange',onVisibility);
    root.querySelectorAll('[data-particle-icon]').forEach(icon=>{
      const paint=icon.getContext('2d');
      if(!paint)return;
      paint.setTransform(2,0,0,2,0,0);
      particle(icon.dataset.particleIcon,14,14,10,1,paint);
    });
    updateMotion();
    function unload(e){if(!e.target.contains(root))return;observer.disconnect();resizeObserver.disconnect();cancelAnimationFrame(frame);video.pause();reduced.removeEventListener('change',onReducedChange);document.removeEventListener('visibilitychange',onVisibility);document.removeEventListener('shopify:section:unload',unload);}
    document.addEventListener('shopify:section:unload',unload);
  }
  document.querySelectorAll('[data-ozj]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>mount(e.target.querySelector('[data-ozj]')));
})();
